export const ACCOUNTING_DEFINITION = 'accounting-definitions';
export const ACCOUNTING_DEFINITION_REMOVE = 'accounting-definitions-remove';
export const ACCOUNTING_DEFINITION_LIST = 'accounting-definitions-list';
export const ACCOUNTING_RULE_LIST = 'accounting-rules';
export const ACCOUNTING_RULE_NEW = 'new-accounting-rules';
export const ACCOUNTING_PARAMETRIZATION = 'accounting-parametrization';
export const ACCOUNTING_MODULES = 'accounting-modules';
export const ACCOUNTING_MODULES_FORM = 'new-accounting-module';
export const ACCOUNTING_MODULES_REMOVE = 'accounting-modules-remove';
export const ACCOUNTING_DICTIONARY_FORM = 'accounting-dictionary-form';
export const ACCOUNTING_DICTIONARY_REMOVE = 'accounting-dictionary-remove';
export const ACCOUNTING_DICTIONARY_NEW = 'new-accounting-dictionary';
export const ACCOUNTING_DICTIONARY_NEW_ATS = 'create-account-data';
export const ACCOUNTING_DICTIONARY_FORM_ATS = 'create-account-data';
export const ACCOUNTING_RULES_ASSIGN = 'accounting-rules-assign';
export const COSTS_CENTERS = 'costs-centers';
export const COSTS_CENTERS_NEW = 'cost-center-new';
export const COSTS_CENTERS_EDIT = 'cost-center-edit';
export const IMPORT_ACCOUNTING_DEFINITION = 'import-accounting-definitions';



// WEBPACK FOOTER //
// ./src/shared/action-codes.js